import React from 'react';
import { useTranslation } from 'react-i18next';

import { Alert, Typography } from '@vivaahealth/design-system';

import styles from './index.module.css';

const ContactsNone: React.FC = () => {
  const { t } = useTranslation('login');
  return (
    <>
      <div className={styles['description-container']}>
        <Typography variant="paragraph-large">
          {t('selectMethodToSendCode')}
        </Typography>
      </div>
      <Alert variant="danger" title={t('noContactMethodOnFile')}>
        {t('contactMethodPrompt')}
        <br />
        <br />
        {t('safeExitMessage')}
      </Alert>
    </>
  );
};

export default ContactsNone;
